import React from 'react'
import ServiceTxnListViewItem from './ServiceTxnListViewItem'

export default ({ serviceTxns, onServiceTxnSelect }) => (
  <div className="border border-gray-200 rounded-lg overflow-hidden">
    {serviceTxns &&
      serviceTxns.map((serviceTxn) => (
        <ServiceTxnListViewItem
          key={serviceTxn._id}
          serviceTxn={serviceTxn}
          onClick={() => onServiceTxnSelect(serviceTxn)}
        />
      ))}
  </div>
)
